import React, { useState } from 'react'
import Topbar from '../../components/Topbar/Topbar'
import { dummyimage, Dummyimage1, toggle_off, toggle_on } from '../../assets/img'
import { useLocation } from 'react-router-dom'
import PropertyDetails from '../../components/RoomListView/PropertyDetails'
import OwnerRecDetails from '../../components/RoomListView/OwnerRecDetails'
import UserDetails from '../../components/RoomListView/UserDetails'
import BookingDetails from '../../components/RoomListView/BookingDetails'
import PriceDetails from '../../components/RoomListView/PriceDetails'
import TransactionDetails from '../../components/RoomListView/TransactionDetails'
import CouponAmount from '../../components/RoomListView/CouponAmount'
import PriceOwnerAdmin from '../../components/RoomListView/PriceOwnerAdmin'

const RoomTransactionView = () => {
    const location = useLocation();
    const type = location?.state?.type;
    const [specialDate, setSpecialDate] = useState(false);


    const details = [
        {
            head: "Property Details",
            id: "VOWP0044",
            name: "Sunshinen Villa",
            location: "Tamil Nadu, Chennai, Anna Nagar",
            images: dummyimage,
        },
        {
            id: "VOWP0044",
            name: "Sunshinen Villa",
            location: "Tamil Nadu, Chennai, Anna Nagar",
            images: dummyimage,
        },
    ]


    return (
        <div>
            <Topbar header={"Booking Transaction View"} subHead={"Overall Properties"} />
            <div className='d-flex flex-wrap gap-5 mt-4'>

                <PropertyDetails />
                <OwnerRecDetails />
                <UserDetails />
                <BookingDetails specialDate={specialDate} setSpecialDate={setSpecialDate} />
                <PriceDetails />
                <TransactionDetails />
                <CouponAmount specialDate={specialDate} setSpecialDate={setSpecialDate} />
                <PriceOwnerAdmin />

            </div>
        </div>
    )
}

export default RoomTransactionView